import { Vec2 } from 'cc';
import BaseRoadmapLayoutStrategy, { RoadmapItemType } from './BaseRoadmapLayoutStrategy';
import { SpinResult } from '../../DataObject/SlotResult';

export default class BasicRoadmapLayoutStrategy extends BaseRoadmapLayoutStrategy {
    public static readonly SPIN_COUNT_PER_ITEM = 10;

    constructor(
        roadmapSize: Vec2,
        maxChunkSize: number,
        spinCountPerItem: number,
        private readonly validSpecialItemTypes: RoadmapItemType[],
    ) {
        super(roadmapSize, maxChunkSize, spinCountPerItem);
    }

    protected doDerive(spinResults: SpinResult[]): void {
        function isSwitchChunkSpinResult(spinResult: SpinResult, validSpecialItemTypes: RoadmapItemType[]): RoadmapItemType {
            if (spinResult.triggerJP && validSpecialItemTypes.includes(RoadmapItemType.JACKPOT)) {
                return RoadmapItemType.JACKPOT;
            }
            if (spinResult.triggerFG && validSpecialItemTypes.includes(RoadmapItemType.FEATURE_GAME)) {
                return RoadmapItemType.FEATURE_GAME;
            }
            if (spinResult.isBigWin && validSpecialItemTypes.includes(RoadmapItemType.BIG_WIN)) {
                return RoadmapItemType.BIG_WIN;
            }
            return null;
        }
        function findNextSwitchChunkSpinResultIndex(fromIndex: number): number {
            return switchChunkSpinResultIndices.findIndex((i) => i > fromIndex);
        }
        const switchChunkSpinResultIndices = spinResults.reduce((indices, spinResult, index) => {
            if (isSwitchChunkSpinResult(spinResult, this.validSpecialItemTypes) !== null) {
                indices.push(index);
            }
            return indices;
        }, []);
        spinResults.forEach((spinResult, idx) => {
            this.itemData.spinResults.push(spinResult);
            const switchChunkType = isSwitchChunkSpinResult(spinResult, this.validSpecialItemTypes);
            if (switchChunkType !== null) {
                this.itemData.type = switchChunkType;
                this.nextChunk();
            } else if (this.itemData.spinResults.length >= this.spinCountPerItem) {
                if (this.itemData.position.y === this.roadmapSize.y - 2) {
                    const nextSwitchChunkSpinResultIndex = switchChunkSpinResultIndices[findNextSwitchChunkSpinResultIndex(idx)];
                    if (nextSwitchChunkSpinResultIndex !== -1 && nextSwitchChunkSpinResultIndex - idx > this.spinCountPerItem) {
                        this.itemData.type = RoadmapItemType.ELLIPSIS;
                    } else {
                        this.itemData.type = RoadmapItemType.TEN_SPINS;
                    }
                    this.nextItem(new Vec2(this.itemData.position.x, this.itemData.position.y + 1));
                } else if (this.itemData.position.y === this.roadmapSize.y - 1) {
                    if (findNextSwitchChunkSpinResultIndex(idx) !== -1) {
                        // ignore spin count per item limit
                        return;
                    }
                    // expand to right
                    if (this.itemData.position.x - this.chunkData.index === this.roadmapSize.x - 2) {
                        this.itemData.type = RoadmapItemType.ELLIPSIS;
                        this.itemData.expanded = true;
                    } else if (this.itemData.position.x - this.chunkData.index === this.roadmapSize.x - 1) {
                        // ignore spin count per item limit
                        return;
                    } else {
                        this.itemData.type = RoadmapItemType.TEN_SPINS;
                    }
                    this.nextItem(new Vec2(this.itemData.position.x + 1, this.itemData.position.y));
                } else {
                    this.itemData.type = RoadmapItemType.TEN_SPINS;
                    this.nextItem(new Vec2(this.itemData.position.x, this.itemData.position.y + 1));
                }
            }
        });
    }

    protected onDeriveFinish(): void {
        if (!this.itemData) {
            return;
        }
        if (this.itemData.type === RoadmapItemType.TEN_SPINS) {
            this.itemData.type = RoadmapItemType.CURRENT;
        }
    }
}
